import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Profile from '@/components/Profile'
import Dashboard from '@/components/Dashboard'
import Courses from '@/components/Courses'
import Certificate from '@/components/Certificate'
import Admin from '@/components/Admin'

import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"

Vue.use(Router)

const router = new Router({
    mode: 'history',

    routes: [
      {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          auth: true
        }
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
          auth: true
        }
      }, 
      {
        path: '/courses',
        name: 'Courses',
        component: Courses,
        meta: {
          auth: true
        }
      }, 
      {
        path: '/verify/:id',
        name: 'Verify',
        component: Certificate,
      }, 
      {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        meta: {
          auth: true
        }
      }, 
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
          guest: true
        }

      },
      {
        path: '/',
        name: 'Home',
        component: Certificate,
      }
    ]

  },

)


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(async function(user) {
      if (user) {
        let privilegesRef = await firebase.firestore().collection("privileges").doc(firebase.auth().currentUser.uid)
        let doc = await privilegesRef.get()
        if (!doc.exists) {
          next({
            path: "/",
          })
        } else {
          if (doc.data().admin || doc.data().manager || doc.data().editor) {
            next()
          } else {
            next({
              path: "/",
            })
          }
        }
      } else {
        next({
          path: "/login",
        })
      }
    })
  } else if (to.matched.some(record => record.meta.guest)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next({
          path: "/dashboard",
        })
      } else {
        next()
      }
    })

  } else {
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js